// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const PORT =
  process.env.REACT_APP_BACK_END_URL_SERVER_HOSTED ||
  process.env.REACT_APP_BACK_END_URL_LOCAL_HOSTED;

export const SubmitContactUsForm = createApi({
  reducerPath: "submitContactUsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: PORT,
  }),
  tagTypes: ["post"],
  endpoints: (builder) => ({
    submitFormByData: builder.mutation({
      query: (payload) => ({
        url: "/contactusform/Submit",
        method: "post",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["post"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useSubmitFormByDataMutation } = SubmitContactUsForm;
